import Login from '@/pages/Login';
import { ROUTES } from './routes.config';

export const LoginRoutes = {
    path: ROUTES.LOGIN,
    element: <Login />,
};
